import { EnglishFlag, SwedishFlag } from "../../assets/icons";
import { LANGUAGE_LIST } from "../../config";

import styles from "./LanguageDropdown.module.scss";

const LanguageDropdown = ({ changeLanguage }) => {
  // toggle language
  const handleChangeLanguage = (lng) => changeLanguage(lng);

  // render
  return (
    <div className={styles.langDropdown}>
      {LANGUAGE_LIST?.map((item) => {
        return (
          <div key={item.id} onClick={() => handleChangeLanguage(item.code)}>
            {item.lang === "English" ? <EnglishFlag /> : null}
            {item.lang === "Svenska" ? <SwedishFlag /> : null}
            {item.lang}
          </div>
        );
      })}
    </div>
  );
};

export default LanguageDropdown;
